export const MODULE_NAME = '@pressreader/views-common';

export const TAG_URL_PREFIX = 'tag-';

/** Gates the "/topics/{slug}-{id}" SEO topic route and slug-shaped tag link generation (PBI 175285). */
export const SEO_TOPIC_ROUTE_CONFIG_KEY = 'UI.Topics.route.enabled';

/**
 * Kill switch for the legacy "/category/tag-{id}" urls (they must eventually 404 per the SEO
 * requirements). Separate from the route flag so old urls can be retired on their own schedule,
 * and active only together with it. With the switch on, a tag navigation that cannot produce a
 * "/topics/{slug}-{id}" url (no slug from any source, no current topic param to reuse) is refused
 * with a logged error — flip only after slugs flow everywhere.
 */
export const SEO_TOPIC_LEGACY_ROUTE_DISABLED_CONFIG_KEY = 'UI.Topics.legacyRoute.disabled';

/**
 * `chatId` values the ask view resolves for a caller that cannot know the real thread id.
 *
 * `ASK_NEW_CHAT` starts a fresh conversation. `ASK_CURRENT_CHAT` continues the one the ask view already
 * has: the nav config's own `chatId` is not usable for this, because a thread created mid-session
 * (`bootstrapNewThread`) only replaces the URL, leaving the config's value stale until the next route parse.
 */
export const ASK_NEW_CHAT = 'new';
export const ASK_CURRENT_CHAT = 'current';
